import Coupon from '../../../models/coupon/Coupon';
import { PeriodType } from '../../../models/coupon/PeriodType';
import moment from 'moment';
import I18n from "i18n-js";
import _ from 'lodash';
import { DateRange, MomentHelper } from "../moment-utility/moment.helper";

export function checkCouponForDateWarning(coupon: Coupon): string {
    if (!coupon?.validTo)
        return '';

    let difference = Math.abs(moment().diff(coupon.validTo, 'day'));

    if (
        (coupon.period?.type === PeriodType.Monthly && difference <= 10) ||
        (coupon.period?.type === PeriodType.Yearly && difference <= 90)
    ) {
        if (difference === 0) difference += 1;
        return I18n.t('tickets.buy.dateWarningDescription', { days: difference });
    }

    return '';
}

export function checkCouponForOverlapWarning(coupon: Coupon, purchasedCoupons: Coupon[]): string {
    if (!coupon?.validTo)
        return '';

    let overlapExists = false;

    purchasedCoupons?.forEach(purchasedCoupon => {
        if (_.intersection(coupon.relation?.trafficAreas, purchasedCoupon.relation?.trafficAreas)?.length) {
            if (MomentHelper.areDateRangesOverlapping(new DateRange(moment(coupon.validFrom), moment(coupon.validTo)), new DateRange(moment(purchasedCoupon.validFrom), moment(purchasedCoupon.validTo)))) {
                overlapExists = true;
            }
        }
    });

    return overlapExists ? I18n.t('tickets.buy.overlapWarningDescription') : '';
}

export function checkCouponForWarnings(coupon: Coupon, purchasedCoupons: Coupon[]) {
    let warningsArray = [];

    if (checkCouponForDateWarning(coupon)) {
        warningsArray.push(checkCouponForDateWarning(coupon));
    }

    if (checkCouponForOverlapWarning(coupon, purchasedCoupons)) {
        warningsArray.push(checkCouponForOverlapWarning(coupon, purchasedCoupons));
    }

    return warningsArray;
};